import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CheckIcon, dayjs, ShortUser } from '@umanforge/common';
import { Note } from 'interfaces/note.interface';
import { TrashIcon } from '@common_components/icons/trash.icon';
import InputText from '@common_components/inputs/textInput.component';


interface NoteTileProps {
  className?: string;
  note: Note
  user: ShortUser
  isAdmin: boolean
  disable?: boolean;
  onInputChange?: () => void;
  onDelete?:() => void;
  onDisable?:() => void;
}

const NoteTile: React.FC<NoteTileProps> = ( {
  className = 'w-full',
  onInputChange = () => { /* */ },
  onDelete = () => { /* */ },
  onDisable = () => { /* */ },
  note,
  isAdmin = false,
  disable = false,
} ) => {
  const { t } = useTranslation();

  const [ noteText, setNoteText ] = useState<string>( note.content ?? '' );

  useEffect( () => {
    note.content = noteText;
    onInputChange();
  }, [ noteText ] );


  return (
    <div className={ 'flex-center border-2 group trans-fast hover:bg-[#faf6f6] rounded-xl p-2 ' + className} >
      <div className='w-full max-w-full'>
        <p className="flex gap-2 items-center text-sm mb-2">
          <span
            className="truncate font-bold max-w-[250px] rounded-lg font-comfortaa px-4 bg-app-color-very-light< text-app-color p-1"
            title={note.authorName}
          >
            {note.authorName}
          </span>
          <span className="whitespace-nowrap text-gray-500">
            {dayjs( note.registerDate ).format( 'L LT' )}
          </span>
        </p>
        <span
          className="p-2 w-full max-w-full flex flex-col justify-center break-words"
        >
          { note.id ?
            ( noteText ).split( '\n' ).map( ( line, lineIndex ) => {
              return ( <div key={lineIndex}> { line } <br/> </div> );
            } ) :
            <InputText
              maxCharacter={ 255 }
              placeholder={ t( 'translation:note' ) + '...' }
              value={ noteText }
              onChange={ setNoteText }
              disable={ note.id != null }
              type='textarea'
              className='w-full max-w-full'
            />
          }
        </span>
      </div>
      { isAdmin && (
        <div className="h-full flex-center w-fit gap">

          {/* Disable for now */}
          { false && note.id != null && !disable && (
            <Button
              tooltip={t( 'translation:disable_note' )}
              icon={<CheckIcon className='w-4 h-4' />}
              className={ note.disabled == true ?
                'text-orange-700 hover:text-orange-700 hover:border-transparent border-orange-600 bg-orange-200 rounded-xl shadow-none hover:bg-orange-300' :
                'text-green-700 hover:text-green-700 hover:border-transparent border-green-600 bg-green-200 rounded-xl shadow-none hover:bg-green-300'
              }
              onClick={ () => {
                note.disabled = !note.disabled ;
                onDisable();
              } }
            />
          )}

          { note.id == null && (
            <Button
              tooltip={t( 'translation:delete_note' )}
              icon={<TrashIcon size={5} />}
              className='p-2 text-red-700 hover:text-red-700 hover:border-transparent border-red-600 bg-red-200 rounded-xl shadow-none hover:bg-red-300'
              onClick={ onDelete }
            />
          )}
        </div>
      )}
    </div>
  );
};

export default NoteTile;
